import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  createDataModel,
  createValidationDataModel,
  setInitialValues,
} from "./notificationSapForm.data.form";
import InputText from "../../../utils/InputText";

const NotificationSapForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, onCancel, showMaterial, title } = props;

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 marg-btm-1rem">
          <h5 className="title">
            {title || t("forms.notificationSap.titleEdit")}
          </h5>
        </div>
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-12">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="sapBatch"
                  className="form-control"
                  labelField={t("forms.notificationSap.labels.sapBatch")}
                  name="sapBatch"
                  component={InputText}
                  fieldType="text"
                  placeholder=""
                  mandatory={showMaterial}
                />
              </div>
            </div>
            {showMaterial && (
              <div className="row mt-2">
                <div className="col-12">
                  <Field
                    id="sapMaterial"
                    className="form-control"
                    labelField={t("forms.notificationSap.labels.sapMaterial")}
                    name="sapMaterial"
                    component={InputText}
                    fieldType="text"
                    placeholder=""
                    mandatory
                  />
                </div>
              </div>
            )}
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="sapQuantityEntry"
                  className="form-control"
                  labelField={t(
                    "forms.notificationSap.labels.sapQuantityEntry",
                  )}
                  name="sapQuantityEntry"
                  component={InputText}
                  fieldType="number"
                  placeholder=""
                  mandatory={showMaterial}
                />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-12 text-center mt-4 mb-3">
                <button
                  type="button"
                  onClick={() => onCancel()}
                  className="btn btn-md btn-secondary me-2"
                >
                  {t("forms.notificationSap.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-md btn-primary">
                  {t("forms.notificationSap.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

NotificationSapForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onCancel: PropTypes.func,
  showMaterial: PropTypes.bool,
  title: PropTypes.string,
};

const NotificationSapFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.showMaterial) {
      return props.initialValues ?? createDataModel;
    }
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    if (props.showMaterial) {
      return createValidationDataModel();
    }
    return validationDataModel();
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "NotificationSapForm",
})(NotificationSapForm);

export default NotificationSapFormF;
